import React, { useEffect, useState } from 'react';

import './index.scss';
import { Menu, MenuItem, Segment } from 'semantic-ui-react';
import SearchableOptions from '../SearchableOptions';
import OfficeViewTeamsSearchResults from '../OfficeViewTeamsSearchResults';
import { Table } from 'dyl-components';
import OfficeViewUser from './OfficeViewUser';

const OfficeViewTeams = ({
    teams = [],
    selectedTeamsTab = "pinned",
    onChangeSelectedTab,
    isReadingExtensionsTeamsList = false,
    searchResults = [],
    getExtensions,
    togglePinnedTeams,
    pinnedUsers,
    isReadingUsers,
    pinsMaxed,
    userPhoneCreds,
    onClickToDialList,
    onEmailClick,
    hasIntegration,
}) => {
    const [search, setSearch] = useState("");
    const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
    const [pinnedUsersDisplay, setPinnedUsersDisplay] = useState([{}, {}, {}])
    const isDisplayingPinnedTab = selectedTeamsTab === "pinned";

    const searchFunction = async () => {
        try {
            setIsSearchResultsVisible(true);
            await getExtensions(search);
        } catch (e) {
            console.log(e)
        }
    }

    const cancelFunction = async () => {
        setSearch("");
        setIsSearchResultsVisible(false);
    };

    const onChangeSearch = (_, { value }) => {
        setSearch(value);
        if (!value) {
            setIsSearchResultsVisible(false);
        }
    }

    const handlePinChange = (id, pinned) => {
        togglePinnedTeams(id, pinned);
        cancelFunction();
    }
    
    useEffect(() => {
        if (isDisplayingPinnedTab) {
            if (pinnedUsers && pinnedUsers.length > 0) {
                const [first, second, third] = pinnedUsers;
                const pinnedAux = [first || {}, second || {}, third || {}]
                setPinnedUsersDisplay(pinnedAux)
            } else {
                setPinnedUsersDisplay([{}, {}, {}])
            }
        } else {
            if (pinnedUsers && pinnedUsers.length > 0) {
                setPinnedUsersDisplay(pinnedUsers)
            } else {
                setPinnedUsersDisplay([])
            }
        }
    }, [pinnedUsers])

    return (
        <Segment className='OfficeView__teamsContainer'>
            <div>
                <div style={{overflow: 'auto', paddingBottom: 10, marginBottom: 20}}>
                    <Menu pointing secondary borderless size={'massive'} color='primary'>
                        <MenuItem 
                            name="pinned"
                            active={isDisplayingPinnedTab}
                            onClick={() => onChangeSelectedTab("pinned")}
                        >
                            Pinned
                        </MenuItem>
                        {teams.map(({id, name}) => (
                            <MenuItem 
                                name={id}
                                active={selectedTeamsTab === id}
                                onClick={() => onChangeSelectedTab(id)}
                            >
                                {name}
                            </MenuItem>
                        ))}
                    </Menu>
                </div>
                {isReadingUsers ? (
                    <Segment basic loading />
                ) : (
                    <>
                        <div>
                            {isDisplayingPinnedTab && (
                                <SearchableOptions
                                    loading={isReadingExtensionsTeamsList}
                                    search={search}
                                    searchFunction={searchFunction}
                                    cancelSearchFunction={cancelFunction}
                                    searchPlaceholder="Search by users or extensions"
                                    onChangeSearch={onChangeSearch}
                                    isSearchResultsVisible={isSearchResultsVisible}
                                    renderSearchResults={
                                        <OfficeViewTeamsSearchResults
                                            searchResults={searchResults}
                                            isReadingExtensionsTeamsList={isReadingExtensionsTeamsList}
                                            togglePinnedTeams={handlePinChange}
                                            pinsMaxed={pinsMaxed} 
                                        />
                                    }
                                    isPaginationVisible={false}
                                    floatingResults
                                />
                            )}
                        </div>
                        <div>
                            <Table celled>
                                <Table.Header primary>
                                    <Table.Row>
                                        <Table.HeaderCell width={3}>User</Table.HeaderCell>
                                        <Table.HeaderCell width={6}>Call</Table.HeaderCell>
                                        <Table.HeaderCell width={1}></Table.HeaderCell>
                                        <Table.HeaderCell width={1}></Table.HeaderCell>
                                        <Table.HeaderCell width={3}>Actions</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {pinnedUsersDisplay.map((user) => (
                                        <OfficeViewUser 
                                            isInPinnedTab={isDisplayingPinnedTab}
                                            isPinLimitReached={pinsMaxed}
                                            togglePin={handlePinChange}
                                            user={user}
                                            key={user.user_id || crypto.randomUUID()}
                                            userPhoneCreds={userPhoneCreds}
                                            onClickToDialList={onClickToDialList}
                                            onEmailClick={onEmailClick}
                                            hasIntegration={hasIntegration}
                                        />
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>
                    </>
                )}
            </div>
        </Segment>
    )
}

export default OfficeViewTeams;
